/* FORTE cart drawer helpers (Dev theme 07.10).
   1. Delivery estimate: fills [data-forte-eta] using UK time, a dispatch cutoff,
      business days and a bank holiday list (Theme settings > FORTE cart drawer).
   2. Best offer banner: when the drawer refuses a code while an automatic discount
      (Buy One Get One 50%) is already on the cart, swap the generic
      "Discount not applicable" message for a clear banner. */
(function () {
  'use strict';

  /* ---------- 1. Delivery estimate ---------- */

  function ukToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: +p.hour, minute: +p.minute };
  }

  function iso(d) { return d.toISOString().slice(0, 10); }

  function isWorkingDay(d, holidays) {
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && !holidays.has(iso(d));
  }

  function addWorkingDays(d, n, holidays) {
    var out = new Date(d.getTime());
    while (n > 0) {
      out.setUTCDate(out.getUTCDate() + 1);
      if (isWorkingDay(out, holidays)) n--;
    }
    return out;
  }

  function fmt(d, withMonth) {
    var opts = { timeZone: 'UTC', weekday: 'short', day: 'numeric' };
    if (withMonth) opts.month = 'short';
    return new Intl.DateTimeFormat('en-GB', opts).format(d).replace(',', '');
  }

  function fillEta(el) {
    var cut = String(el.getAttribute('data-cutoff') || '14:00').split(':');
    var cutH = parseInt(cut[0], 10) || 14;
    var cutM = parseInt(cut[1], 10) || 0;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1;
    var max = parseInt(el.getAttribute('data-max'), 10) || min;
    var holidays = new Set(String(el.getAttribute('data-holidays') || '').split(/[\s,]+/).filter(Boolean));

    var now = ukToday();
    var beforeCutoff = now.hour < cutH || (now.hour === cutH && now.minute < cutM);
    /* Dispatched the same working day when ordered before the cutoff, otherwise the next working day. */
    var dispatch = (isWorkingDay(now.date, holidays) && beforeCutoff) ? now.date : addWorkingDays(now.date, 1, holidays);
    var from = addWorkingDays(dispatch, min, holidays);
    var to = addWorkingDays(dispatch, max, holidays);

    var label = el.getAttribute('data-label') || 'Arrives';
    var text;
    if (iso(from) === iso(to)) {
      text = label + ' ' + fmt(from, true);
    } else {
      var sameMonth = from.getUTCMonth() === to.getUTCMonth();
      text = label + ' between ' + fmt(from, !sameMonth) + ' and ' + fmt(to, true);
    }
    var target = el.querySelector('[data-forte-eta-text]');
    if (target) target.textContent = text;
    el.hidden = false;
    el.setAttribute('data-forte-eta-done', '');
  }

  function fillAll(root) {
    (root || document).querySelectorAll('[data-forte-eta]:not([data-forte-eta-done])').forEach(fillEta);
  }

  /* ---------- 2. Best offer banner ---------- */

  var bestOffer = window.forteBestOffer || {};

  // /cart.js returns automatic discounts (Buy One Get One) with type "" rather than "automatic",
  // so anything that is not a discount code counts as automatic.
  function isAutomatic(application) {
    return !!application && application.type !== 'discount_code';
  }

  function hasAutomaticDiscount(cart) {
    var auto = (cart.cart_level_discount_applications || []).some(isAutomatic);
    if (auto) return true;
    return (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        return isAutomatic(a.discount_application);
      });
    });
  }

  function automaticTitle(cart) {
    var title = '';
    (cart.items || []).some(function (item) {
      return (item.line_level_discount_allocations || []).some(function (a) {
        if (isAutomatic(a.discount_application)) { title = a.discount_application.title; return true; }
        return false;
      });
    });
    return title;
  }

  function checkDiscountMessage(msg) {
    if (!bestOffer.enabled || msg.classList.contains('hidden') || msg.hasAttribute('data-forte-checking')) return;
    var generic = (window.theme && window.theme.strings && window.theme.strings.discount_not_applicable) || 'Discount not applicable';
    if (msg.textContent.trim() !== generic.trim()) return;
    msg.setAttribute('data-forte-checking', '');
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!hasAutomaticDiscount(cart)) return;
        var offer = automaticTitle(cart) || 'Buy One Get One 50%';
        msg.classList.add('forte-best-offer');
        msg.innerHTML = '';
        var strong = document.createElement('strong');
        strong.textContent = bestOffer.title || "You've already got the best offer.";
        msg.appendChild(strong);
        if (bestOffer.detail) {
          var small = document.createElement('span');
          small.textContent = bestOffer.detail.replace('{offer}', offer);
          msg.appendChild(small);
        }
      })
      .catch(function () {})
      .then(function () { msg.removeAttribute('data-forte-checking'); });
  }

  function resetDiscountMessage(msg) {
    if (msg.classList.contains('hidden') && msg.classList.contains('forte-best-offer')) {
      msg.classList.remove('forte-best-offer');
    }
  }

  /* ---------- Wiring ---------- */

  var queued = false;
  function scan() {
    queued = false;
    fillAll(document);
    document.querySelectorAll('[data-discount-error-message]').forEach(function (msg) {
      resetDiscountMessage(msg);
      checkDiscountMessage(msg);
    });
  }
  function queueScan() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(scan);
  }

  function start() {
    scan();
    var targets = Array.prototype.slice.call(document.querySelectorAll('cart-element, cart-items, [data-cart-drawer]'));
    if (!targets.length) targets = [document.body];
    var observer = new MutationObserver(queueScan);
    targets.forEach(function (t) {
      observer.observe(t, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
    /* Re-check the date every 10 minutes so an open page rolls past the cutoff correctly. */
    setInterval(function () {
      document.querySelectorAll('[data-forte-eta-done]').forEach(function (el) { el.removeAttribute('data-forte-eta-done'); });
      fillAll(document);
    }, 600000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
